// BurnFeed — recent burns activity feed (last 20, dark style, animated flame).
import React from "react";
import { Flame, ExternalLink } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";
import { tBurn, timeAgo } from "../../i18n/burn";

const fmt = (n) => Number(n).toLocaleString();

export default function BurnFeed({ burns }) {
  const { lang } = useLanguage();
  const t = (k) => tBurn(lang, k);

  return (
    <div data-testid="burn-feed">
      <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">{t("recentBurns")}</p>
      {!burns?.length ? (
        <p className="mt-3 rounded-xl bg-white/[0.03] p-4 text-center text-xs text-white/35" data-testid="burn-feed-empty">
          {t("empty")}
        </p>
      ) : (
        <div className="mt-3 max-h-64 space-y-1.5 overflow-y-auto pr-1">
          {burns.map((b, i) => (
            <div key={b.burn_tx_hash || i}
              className="flex flex-wrap items-center justify-between gap-2 rounded-xl border border-orange-400/10 bg-white/[0.03] px-3 py-2.5 text-xs">
              <span className="flex items-center gap-2 text-white/70">
                <Flame className={`h-3.5 w-3.5 ${b.type === "voluntary" ? "text-fuchsia-400" : b.type === "market" ? "text-cyan-400" : "text-orange-400"} ${i === 0 ? "animate-pulse" : ""}`} />
                <span className="font-mono text-white/40">{timeAgo(lang, b.burned_at)}</span>
                <span className="font-mono font-bold text-orange-300">{fmt(b.amount_rbl)} R₿L</span>
                <span className={`rounded-full border px-1.5 py-0.5 font-mono text-[8px] font-black uppercase tracking-wider ${
                  b.type === "voluntary"
                    ? "border-fuchsia-400/40 bg-fuchsia-400/10 text-fuchsia-300"
                    : b.type === "market"
                    ? "border-cyan-400/40 bg-cyan-400/10 text-cyan-300"
                    : "border-amber-400/30 bg-amber-400/[0.06] text-amber-300/80"
                }`}>
                  {b.type === "voluntary" ? t("typeVoluntary") : b.type === "market" ? t("typeMarket") : t("typePro")}
                </span>
              </span>
              {b.burn_tx_hash && (
                <a href={`https://basescan.org/tx/${b.burn_tx_hash}`} target="_blank" rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 font-bold text-orange-300/80 underline hover:text-orange-300">
                  {t("viewTx")} <ExternalLink className="h-3 w-3" />
                </a>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
